import { render, staticRenderFns } from "./Formazione.vue?vue&type=template&id=b3609b1c&scoped=true&"
import script from "./Formazione.vue?vue&type=script&lang=js&"
export * from "./Formazione.vue?vue&type=script&lang=js&"
import style0 from "./Formazione.vue?vue&type=style&index=0&id=b3609b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3609b1c",
  null
  
)

export default component.exports